import styled from "styled-components";

export const InlineCalendarStyles = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  .react-datepicker {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    border: none;
    border-radius: ${({ theme }) => theme.radius[12]};
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    width: 100%;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__month-container {
    padding: ${({ theme }) => theme.spacing[8]};
    width: 100%;
    float: unset;
  }

  .react-datepicker__header {
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border-bottom: none;
    padding-top: ${({ theme }) => theme.spacing[8]};
  }

  .react-datepicker__current-month,
  .react-datepicker-year-header {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
  }

  .react-datepicker__navigation {
    top: 14px;
    width: 28px;
    height: 28px;
    border: none;
  }

  .react-datepicker__navigation--previous {
    left: ${({ theme }) => theme.spacing[12]};
  }

  .react-datepicker__navigation--next {
    right: ${({ theme }) => theme.spacing[12]};
  }

  .react-datepicker__navigation-icon::before {
    border-color: ${({ theme }) => theme.colors.semantic.text.strong};
    border-width: 2px 2px 0 0;
    width: 8px;
    height: 8px;
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    display: flex;
    justify-content: space-between;
  }

  .react-datepicker__day-name {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    width: 36px;
    line-height: 36px;
    margin: 2px;
  }

  .react-datepicker__day {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 50%;
    margin: 2px;
    transition: background-color 0.15s ease;

    &:hover {
      border-radius: 50%;
      background-color: ${({ theme }) => theme.colors.accent[50]};
    }
  }

  .react-datepicker__day--today {
    font-weight: normal !important;
    background-color: ${({ theme }) => theme.colors.accent[200]};
    color: ${({ theme }) => theme.colors.semantic.container.white};
    border-radius: 50%;

    &:hover {
      background-color: ${({ theme }) => theme.colors.accent[200]};
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    border: 1.5px solid ${({ theme }) => theme.colors.semantic.text.strong};
    border-radius: 50%;

    &:hover {
      background-color: ${({ theme }) => theme.colors.accent[50]};
      border-radius: 50%;
    }
  }

  .react-datepicker__day--keyboard-selected {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.semantic.text.strong};

    &:hover {
      background-color: ${({ theme }) => theme.colors.accent[50]};
      border-radius: 50%;
    }
  }

  .react-datepicker__day--outside-month {
    color: ${({ theme }) => theme.colors.semantic.text.placeholder};
  }
`;
